import React from 'react';
import './SlideOutPanel.css';

/**
 * 일반 검색 결과를 테이블 형태로 표시하는 컴포넌트
 */
const SearchResultsDisplay = ({ 
  results, 
  displayFields, 
  onEdit, 
  onDelete,
  isLoading = false 
}) => {
  // 필드 값을 포맷팅
  const formatFieldValue = (value, fieldConfig) => {
    if (value === null || value === undefined) {
      return '-';
    }

    // Boolean 타입 포맷팅
    if (fieldConfig.type === 'boolean') {
      if (fieldConfig.boolean_labels) {
        return value ? fieldConfig.boolean_labels.true : fieldConfig.boolean_labels.false;
      }
      return value ? 'true' : 'false';
    }

    // Badges 타입 포맷팅 (콤마로 구분된 값들을 배지로 표시)
    if (fieldConfig.type === 'badges') {
      const separator = fieldConfig.separator || ', ';
      const badgeColor = fieldConfig.badge_color || 'primary';
      const values = value ? String(value).split(separator).filter(v => v.trim()) : [];

      if (values.length === 0) {
        return '-';
      }

      return (
        <div className="badges-container">
          {values.map((val, index) => (
            <span key={index} className={`badge badge-${badgeColor}`}>
              {val.trim()}
            </span>
          ))}
        </div>
      );
    }

    // Badge 타입 포맷팅 (단일 배지)
    if (fieldConfig.type === 'badge') {
      const badgeColors = fieldConfig.badge_colors || {};
      const colorClass = badgeColors[value] || 'default';

      return (
        <span className={`badge badge-${colorClass}`}>
          {value}
        </span>
      );
    }

    // 날짜/시간 필드 포맷팅
    if (fieldConfig.field.includes('datetime') || fieldConfig.field.includes('_date')) {
      try {
        const date = new Date(value);
        return date.toLocaleString('ko-KR');
      } catch {
        return String(value);
      }
    }

    // 비용 관련 필드 포맷팅
    if (fieldConfig.field.includes('cost') && typeof value === 'number') {
      return value.toLocaleString('ko-KR') + '원';
    }

    // 긴 텍스트 자르기
    const str = String(value);
    if (str.length > 50) {
      return str.substring(0, 50) + '...';
    }

    return str;
  };

  if (isLoading) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        color: '#6b7280'
      }}>
        <div style={{ fontSize: '24px', marginBottom: '16px' }}>⏳</div>
        <div>검색 중...</div>
      </div>
    );
  }

  if (!results || results.length === 0) {
    return (
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        color: '#6b7280'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px', opacity: 0.6 }}>👥</div>
        <div style={{ fontSize: '18px', marginBottom: '12px', fontWeight: '500' }}>
          등록된 사용자가 없습니다
        </div>
        <div style={{ fontSize: '14px', opacity: 0.8, lineHeight: '1.5' }}>
          "새 사용자 추가" 버튼을 클릭하여<br/>
          첫 번째 사용자를 등록해보세요
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* 결과 개수 표시 */}
      <div style={{
        padding: '12px 0',
        borderBottom: '2px solid #f3f4f6',
        marginBottom: '16px'
      }}>
        <span style={{
          fontSize: '14px',
          color: '#6b7280',
          fontWeight: '500'
        }}>
          총 <strong style={{ color: '#111827' }}>{results.length}개</strong>의 결과
        </span>
      </div>

      {/* 검색 결과 테이블 */}
      <table className="search-results-table">
        <thead>
          <tr>
            {displayFields.map((field) => (
              <th key={field.field}>
                {field.label}
              </th>
            ))}
            <th style={{ width: '120px' }}></th>
          </tr>
        </thead>
        <tbody>
          {results.map((record, index) => (
            <tr key={index}>
              {displayFields.map((field) => (
                <td key={field.field}>
                  {formatFieldValue(record[field.field], field)}
                </td>
              ))}
              <td>
                <div style={{ 
                  display: 'flex', 
                  gap: '8px',
                  justifyContent: 'center'
                }}>
                  {onEdit && (
                    <button
                      onClick={() => onEdit(record)}
                      style={{
                        background: '#3b82f6',
                        color: 'white',
                        border: 'none',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        transition: 'background 0.2s ease'
                      }}
                      onMouseOver={(e) => e.target.style.background = '#2563eb'}
                      onMouseOut={(e) => e.target.style.background = '#3b82f6'}
                      title="수정"
                    >
                      ✏️
                    </button>
                  )}
                  {onDelete && (
                    <button
                      onClick={() => onDelete(record)}
                      style={{
                        background: '#dc2626',
                        color: 'white',
                        border: 'none',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        transition: 'background 0.2s ease'
                      }}
                      onMouseOver={(e) => e.target.style.background = '#b91c1c'}
                      onMouseOut={(e) => e.target.style.background = '#dc2626'}
                      title="삭제"
                    >
                      🗑️
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SearchResultsDisplay; 